import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {KeycloakService} from 'keycloak-angular';
import {take} from 'rxjs/operators';
import {BasicPersonDetailDTO} from '../../../../ent/models/person/BasicPersonDetailDTO';
import {DeathStatusService} from '../../../../ent/services/death-status.service';
import {DeathStatusDTO} from '../../../../ent/models/DeathStatusDTO';
import {SharedService} from '../../../services/shared-service';
import {DateUtil} from '../../../util/DateUtil';
import {Role} from '../../../../clm/types/role.enum';

@Component({
  selector: 'app-home-affairs-person-profile',
  templateUrl: './home-affairs-person-profile.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class HomeAffairsPersonProfileComponent implements OnInit {

  dateFormat: string;
  userRoles: string[];
  deathStatus: DeathStatusDTO;

  constructor(
    private deathStatusService: DeathStatusService,
    private sharedService: SharedService,
    private keycloakService: KeycloakService,
    public dialogRef: MatDialogRef<HomeAffairsPersonProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public basicPersonDetails: BasicPersonDetailDTO
  ) {
  }

  ngOnInit(): void {
    this.dateFormat = DateUtil.dateFormat;
    this.userRoles = this.keycloakService.getUserRoles();
    this.getDeathStatusByPersonId(this.basicPersonDetails.personId);
  }

  updateDeathStatus() {
    this.getDeathStatusByPersonIdFromVendor(this.basicPersonDetails.personId);
  }

  disableUpdateButton(): boolean {
    let disabled = true;
    if (this.userRoles.find(role => role === Role.ClaimsTeamLeader) || this.userRoles.find(role => role === Role.PreAuthorisationTeamLeader)) {
      disabled = false;
    }
    return disabled;
  }

  idMatchedDisplayString(): string {
    return this.deathStatus.idMatch != null && this.deathStatus.idMatch.toLowerCase() === 'matched' ? 'YES' : 'NO';
  }

  fullNameDisplayString(): string {
    return (this.deathStatus.title != null && this.deathStatus.title !== '' ? (this.deathStatus.title + ' ') : '') + this.deathStatus.firstNames + ' ' + this.deathStatus.surname;
  }

  private getDeathStatusByPersonId(personId: number) {
    this.deathStatusService.getDeathStatusByPersonId(personId)
      .pipe(
        take(1),
      )
      .subscribe(
        (deathStatus: DeathStatusDTO) => {
          this.deathStatus = deathStatus;
        },
        (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openSnackBar(error.businessMessage, 'Dismiss');
        }
      );
  }

  private getDeathStatusByPersonIdFromVendor(personId: number) {
    this.deathStatusService.getDeathStatusByPersonIdFromVendor(personId)
      .pipe(
        take(1),
      )
      .subscribe(
        (deathStatus: DeathStatusDTO) => {
          this.deathStatus = deathStatus;
        },
        (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openSnackBar(error.businessMessage, 'Dismiss');
        }
      );
  }

}
